import type { MarketType } from '@ps/web-sports-api-types';
import { oddsBoostMarkets } from '@ps/web-sports-enums';

export type OddsBoostMarket = (typeof oddsBoostMarkets)[number];

export const getIsOddsBoostMarket = (market?: MarketType): market is OddsBoostMarket =>
  oddsBoostMarkets.includes(market as OddsBoostMarket);
